import React, { useEffect, useState, useRef } from 'react';
import { Routes, useNavigate, useLocation } from "react-router-dom";

import routes from '../../libs/routes';
import images from "../../libs/images";
import * as API from "../../libs/service";


import { useDispatch, useSelector } from 'react-redux';

import { loadingStart, loadingEnd } from "../../redux/loadingSlice";
import { open, close } from "../../redux/popupSlice";

import Popup01 from "../../pages/popup/Popup01"
import PopupPlanModel from "../../pages/popup/PopupPlanModel"
import ModelOptionCard from "../../components/ModelOptionCard"

import { ToastContainer, toast, Slide, Flip, Bounce } from 'react-toastify';
import { BrowserView, MobileView, isBrowser, isMobile, isChrome, isSafari, isIOS, isAndroid, ConsoleView } from 'react-device-detect';
import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode, Autoplay } from 'swiper/modules';
import moment from "moment";



import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/autoplay';
import 'react-toastify/dist/ReactToastify.css';

import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";

export default function CancelSub() {
    
    const location = useLocation();
    const { 
        infolicense,
        infoTitle,
        subscribelist,
        payList
    } = location.state || {};

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { mbData } = useSelector((s) => s.usersReducer);

    const fileRef = useRef();

    const [detailView1, setDetailView1] = useState(false);
    const [detailView2, setDetailView2] = useState(false);
    const [detailView3, setDetailView3] = useState(false);
    const [detailView4, setDetailView4] = useState(false);
    const [endDates, setendDates] = useState({});
    const [latestDate, setlatestDate] = useState('');

    const lang = useSelector(state => state.langReducer.lang);

    useEffect(() => {
        let paylists = payList?.filter(item => item?.ingstate*1 === 0)[payList?.filter(item => item?.ingstate*1 === 0)?.length-1];
        setendDates(moment(subscribelist?.endDate).format('YYYY-MM-DD HH:mm'));
        window.scrollTo(0, 0);
        // payList?.filter(item => item?.ingstate*1 === 1 && item?.subscriptionId*1 === subscribelist?.id)?.map((x, i) => {
        //     console.log(moment(x?.pay_dt).format('YYYY-MM-DD HH:mm:ss'));
        // });
        setlatestDate(payList?.filter(item => item?.ingstate*1 === 1 && item?.subscriptionId*1 === subscribelist?.id)[0]?.pay_dt);
        console.log(payList?.filter(item => item?.ingstate*1 === 1 && item?.subscriptionId*1 === subscribelist?.id))
        console.log(subscribelist)
    }, [payList, subscribelist]);
    
    useEffect(() => {
        if(!mbData?.idx) {
            navigate(routes.main);
        }
    }, []);
    
    return (
        <>
            <div className="main_back">
                <div className="main_part profile padding">
                    <div className="profile_edit_box">
                        <div 
                            className="title_box"
                            onClick={() => {
                                navigate(-1);
                            }}
                        >
                            <img src={require("../../assets/icon/back_arr.svg").default}/>
                            <p>{lang === 0 ? '구매한 제품' : 'Purchased Product'}</p>
                        </div>

                        <div className="cancelsub_box">
                            <div className="cancelsub_part main">
                                <div className="title">
                                    <img src={require("../../assets/icon/close.svg").default}/>
                                    {lang === 0 ? '구독 해지' : 'Cancel Subscription'}
                                </div>

                                <p className="sub_title">UModeler X {infoTitle}</p>

                                <div className="cancelsub_radio_box" style={{ alignItems: 'center', justifyContent: 'center'}}>
                                    <div className="custom_chk_box profile lang">
                                        <label htmlFor="cancel_sub_go1" className="custom_chk_label">
                                            {lang === 0 ? '라이선스 해지:' : 'Cancel License:'}
                                            <b> {infolicense}</b>
                                        </label>
                                    </div>

                                    {/* <div className="custom_chk_box profile lang">
                                        <input 
                                            type="radio" 
                                            className="custom_chk_input" 
                                            name="cancel_sub_go"
                                            id="cancel_sub_go2"
                                        />
                                        <label htmlFor="cancel_sub_go2" className="custom_chk_label">
                                            {lang === 0 ? '구독 전체 해지:' : 'Cancel Entire Subscription:'}
                                            <b> ABCD12345</b>
                                        </label>
                                    </div> */}
                                </div>

                                <div className="comment">
                                    <p className="red"> 
                                        {lang === 0 ? `구독 해지시 ${endDates} 까지만 이용 가능하며,` : `After cancellation, service available until ${endDates},`}<br />
                                        {lang === 0 ? '자동 결제가 해지됩니다.' : 'Auto payment will be stopped.'}
                                    </p>

                                    {/* <p className="red"> 
                                        {lang === 0 ? '14일 이후 취소 시,' : 'If canceled after 14 days,'}<br />
                                        {lang === 0 ? '남은 계약 기간에 대해 50%의 해지 수수료가 부과됩니다.' : 'a 50% cancellation fee will apply for remaining period.'}
                                    </p> */}

                                    {/* <p> 
                                        {lang === 0 ? '고객님은 전액 환불 대상입니다.' : 'You are eligible for full refund.'}
                                    </p> */}

                                    <span>
                                        {lang === 0 ? '자동 결제를 해지하시겠습니까?' : 'Do you want to cancel auto payment?'}
                                    </span>

                                    {/* <span>
                                        {lang === 0 ? '구독을 해지하시겠습니까?' : 'Do you want to cancel the subscription?'}
                                    </span> */}
                                </div>

                                <div className="btn_box">
                                    <button
                                        type="button"
                                        className="cancel"
                                        onClick={() => {
                                            navigate(-1);
                                        }}
                                    >
                                        {lang === 0 ? '닫기' : 'Close'}
                                    </button>

                                    <button
                                        type="button"
                                        className="suc"
                                        onClick={async() => {
                                            dispatch(loadingStart());
                                            const result = await API.xsollaApis("user/subscribecancle", {id: subscribelist?.id});
                                            //console.log(result);
                                            if (result?.status === 200) {
                                                navigate(routes.Licensing);
                                                dispatch(open({
                                                    component: 
                                                        <Popup01
                                                            max_width={'300px'}
                                                            x_btn={false}
                                                            text1={lang === 0 ? '구독이 해지되었습니다.' : 'Subscription has been canceled.'}
                                                            longButton={lang === 0 ? '확인' : 'OK'}
                                                        />
                                                }));
                                                dispatch(loadingEnd());
                                            }
                                            if (result?.status === 400) {
                                                dispatch(open({
                                                    component:
                                                        <Popup01
                                                            max_width={'300px'}
                                                            x_btn={false}
                                                            text1={result?.message}
                                                            longButton={lang === 0 ? '확인' : 'OK'}
                                                        />
                                                }));
                                            }
                                        }}
                                    >
                                        {lang === 0 ? '구독 해지' : 'Cancel Subscription'}
                                    </button>
                                </div>
                            </div>

                            <div className="cancelsub_part sub">
                                <div className="title_box">
                                    <p>{lang === 0 ? '구독 해지' : 'Cancel Subscription'}</p>
                                    <span>{lang === 0 ? '구독을 해지하시면 다음 결제일부터 정기 요금이 발생하지 않습니다.' : 'No charges from next billing date after cancellation.'}</span>
                                </div>

                                <div className="info_box">
                                    <div className="info">
                                        <p>{lang === 0 ? '청구 옵션' : 'Billing Option'}</p>
                                        <span>
                                            {subscribelist?.planYorM*1 === 1 ?
                                                <>{lang === 0 ? '월간 결제' : 'Monthly Billing'}</>
                                            :
                                                <>{lang === 0 ? '연간 결제' : 'Year Billing'}</>
                                            }
                                            
                                        </span>
                                    </div>

                                    <div className="info">
                                        <p>{lang === 0 ? '구독 시작일' : 'Start Date'}</p>
                                        <span>{moment(subscribelist?.startDate).format('YYYY-MM-DD HH:mm')}</span>
                                    </div>

                                    <div className="info">
                                        <p>{lang === 0 ? '최근 결제일' : 'Last Payment Date'}</p>
                                        <span>{moment(latestDate).format('YYYY-MM-DD HH:mm')}</span>
                                    </div>

                                    {/* <div className="info red">
                                        <p>{lang === 0 ? '남은 기간' : 'Remaining Period'}</p>
                                        <span>{lang === 0 ? '3개월' : '3 months'}</span>
                                    </div> */}

                                    <div className="info red">
                                        <p>{lang === 0 ? '다음 결제일' : 'Next Billing Date'}</p>
                                        <span>{lang === 0 ? '미발생(구독해지)' : 'Not Applicable (Canceled)'}</span>
                                    </div>

                                    {/* <div className="info red">
                                        <p>{lang === 0 ? '환불 금액' : 'Refund Amount'}</p>
                                        <span>₩60,000</span>
                                    </div> */}
                                </div>

                                {/* <p className="sub_text">{lang === 0 ? '환불 신청 후 카드사에 따라 3~5일정도 소요됩니다.' : 'Refund may take 3~5 days depending on your card company.'}</p> */}
                                <div className="sub_text_box">
                                    <p>{lang === 0 ? '구독기간이 남은 기간동안은 서비스 이용이 가능합니다.' : 'Service is available until end of current subscription.'}</p>
                                    <span>{lang === 0 ? `${endDates} 까지` : `Until ${endDates}`}</span>
                                </div>

                                <div className="title_box two">
                                    <p>{lang === 0 ? '환불 기준' : 'Refund Policy'}</p>
                                    <span>{lang === 0 ? 'SW를 설치한 경우 환불이 불가능합니다.' : 'Refunds cannot be issued after the software has been installed.'}</span>
                                </div>

                                {/* <div className="PaginationContent cancelsub">
                                    <div className="my_coupon_list_box">
                                        <div className="list_title">
                                            <p>{lang === 0 ? '청구 옵션' : 'Billing Option'}</p>
                                            <p>{lang === 0 ? '무료 이용 기간 이내' : 'Within Free Trial'}</p>
                                            <p>{lang === 0 ? '무료 이용 기간 이후' : 'After Free Trial'}</p>
                                        </div>

                                        <div className="my_coupon_info">
                                            <p>{lang === 0 ? '월간 구독' : 'Monthly Subscription'}</p>
                                            <p>{lang === 0 ? '취소 가능' : 'Cancelable'}</p>
                                            <p>{lang === 0 ? '환불 불가' : 'Non-refundable'}</p>
                                        </div>

                                        <div className="my_coupon_info">
                                            <p>{lang === 0 ? '연 구독' : 'Annual Subscription (One-time)'}</p>
                                            <p>{lang === 0 ? '취소 가능' : 'Cancelable'}</p>
                                            <p>{lang === 0 ? '환불 불가' : 'Non-refundable'}</p>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div> {/* 메인 div */}

            <ToastContainer
                position="bottom-center"
                transition={Slide}
                limit={1}
                closeButton={false}
                autoClose={1000}
                style={{ width: isBrowser ? 400 : '100%', marginBottom: isBrowser ? 60 : 70 }}
                hideProgressBar
            />
        </>
    );
}
